import { useAuthContext } from '@/components/Providers/AuthProvider';
import { usePdfContext } from '@/components/Providers/PdfProvider';
import { CircularSpotifyText } from '@/config/fonts';
import useWebAlias from '@/helpers/hooks/useWebalias';
import { useAppContext } from '@/layouts/AppProvider';

import FooterPrivacyPreferenceLink from '../../AccountSetting/PrivacyPreference/FooterPrivacyPerferenceLink';

export default function FootNote() {
  const { generateURL, webalias } = useWebAlias();
  const { isBackOffice } = useAppContext();
  const { customer } = useAuthContext();
  const { getPdfById } = usePdfContext();
  const privacyPolicyPdf = getPdfById(1); // Privacy Policy (ID: 1)

  return (
    <div className={`v2-bg-primary-600 v2-mt-0 container mb-0 border-0 sm:max-w-full ${CircularSpotifyText.className}`}>
      <div
        className={` v2-bg-primary-600 v2-border-t md:!v2-max-w-[1080px] md:v2-px-0 !v2-mx-auto sm:v2-px-0 v2-border-[#C8D2D1] v2-pt-6 v2-pb-[51px] sm:!v2-max-w-full flex flex-row justify-between font-light sm:mx-2 md:mx-10 xs:flex-col-reverse xs:items-center xs:gap-2`}
      >
        <div>
          <p className="v2-text-xs v2-font-sweet-sans-pro-light v2-font-light v2-text-white sm:text-center">
            <>&copy;{new Date().getFullYear()} </>
            pawTree, LLC. <>All Rights Reserved</>
          </p>
        </div>

        <div>
          <ul className="v2-text-xs v2-font-sweet-sans-pro-light v2-gap-6 flex flex-row justify-center">
            <li>
              <a
                href={
                  (isBackOffice ? 'https://shop.pawtree.com' : '') +
                  generateURL('/pages/terms-of-use', isBackOffice ? customer?.webAlias || customer?.company : webalias)
                }
                className="v2-text-white hover:opacity-70 hover:transition-opacity"
              >
                Terms of Use
              </a>
            </li>
            {privacyPolicyPdf?.pdfLink && (
              <li>
                <a
                  href={privacyPolicyPdf.pdfLink}
                  target="_blank"
                  className="v2-text-white hover:opacity-70 hover:transition-opacity"
                >
                  {privacyPolicyPdf.name}
                </a>
              </li>
            )}
            <li>
              <a
                href={
                  (isBackOffice ? 'https://shop.pawtree.com' : '') +
                  generateURL('/dsa', isBackOffice ? customer?.webAlias || customer?.company : webalias)
                }
                className="v2-text-white hover:opacity-70 hover:transition-opacity"
              >
                DSA
              </a>
            </li>
            <li>
              <FooterPrivacyPreferenceLink
                href={generateURL('/account/privacypreference', isBackOffice ? customer?.webAlias : webalias)}
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
